import * as React from 'react';
import {Button, ButtonProps} from '../Button';
import {ACTION_COLOR_MAP} from './_consts';
import {ToastAction, ToastType} from './_types';

type ToastButtonProps = {
  action: ToastAction;
  handleClose: () => void;
  toastVariant: ToastType;
};

/**
 * A button mapped and rendered through the action prop within ToastBody.
 */
const ToastButton = ({action, handleClose, toastVariant}: ToastButtonProps) => {
  const {href, onClick, shouldCloseOnClick, target, text} = action;

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    onClick?.(event);

    if (shouldCloseOnClick) {
      handleClose();
    }
  };

  return (
    <Button
      colorVariant={
        ACTION_COLOR_MAP[toastVariant] as ButtonProps['colorVariant']
      }
      href={href}
      isFullWidth={false}
      onClick={handleClick}
      target={target}
      variant="outline"
    >
      {text}
    </Button>
  );
};

export {ToastButton};
